import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import NativeTable from '../../../../components/NativeTable/NativeTable';
import { Alert, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Loader from '../../../../components/Loader/Loader';
import { createVideo, updateVideo, deleteVideo } from '../../../../actions/settings';
import { IMAGE_PRESETS, processImageFileInput, revokeImagePreviewUrl } from '../../../../utils/imageUtils';
import { toast } from 'react-toastify';

import screen from '../CustomerScreen.module.scss';
import { withTranslation } from '../../../../i18n/LanguageContext';

class Videos extends React.Component {

    static propTypes = {
        dispatch: PropTypes.func.isRequired,
    };

    state = {
        isAddModal: false,
        deleteAssetId: null,
        videoName: "",
        curVideo: null,
        videoError: "",
        videoFile: null,
        posterFile: null,
        tempPicture: "",
        editError: ""
    };

    constructor() {
        super();

        this.changeName = this.changeName.bind(this);
        this.changeVideo = this.changeVideo.bind(this);
        this.changePicture = this.changePicture.bind(this);
        this.changeEditVideoName = this.changeEditVideoName.bind(this);
        this.apiFormatter = this.apiFormatter.bind(this);
    }

    changeName(event) {
        this.setState({ videoName: event.target.value, videoError: "" });
    }

    changeVideo(event) {
        if (event.target.files && event.target.files[0]) {
            const file = event.target.files[0];
            this.setState({
              videoFile: file
            });
        } else {
            this.setState({videoFile: null});
        }
    }

    async changePicture(event) {
        const input = event.target;
        const file = input.files && input.files[0];

        if (!file) {
            revokeImagePreviewUrl(this.state.tempPicture);
            this.setState({ posterFile: null, tempPicture: "" });
            return;
        }

        try {
            const result = await processImageFileInput(
                file,
                this.state.tempPicture,
                IMAGE_PRESETS.product
            );
            this.setState({
                tempPicture: result.previewUrl,
                posterFile: result.file,
            });
        } catch (error) {
            console.error('[Videos] changePicture failed', error);
            revokeImagePreviewUrl(this.state.tempPicture);
            this.setState({ posterFile: null, tempPicture: "" });
            toast.error(error.message || 'Could not use that photo. Try again with a smaller image.');
        } finally {
            input.value = '';
        }
    }

    changeEditVideoName(event) {
        var curVideo = this.state.curVideo;
        curVideo.Name = event.target.value;
        this.setState({ curVideo: curVideo, editError: "" });
    }

    onClickSaveVideo = (e) => {
        e.preventDefault();

        var videoError = "";
        const {videoName, videoFile, posterFile} = this.state;

        if (videoName == "") {
            videoError = "Please input a video name";
        } else if (videoFile == null) {
            videoError = "Please input a video file";
        } else if (posterFile == null) {
            videoError = "Please input a poster picture file";
        }

        if (videoError == "") {
            this.props.dispatch(createVideo({
                videoFile,
                posterFile,
                videoName
            }))
        }
        this.setState({videoError: videoError});
    }

    onClickUpdate = (event) => {
        event.preventDefault();

        const { curVideo } = this.state;

        var editError = "";
        if (curVideo.Name == "") {
            editError = "Please input the video name";
        }

        if (editError == "") {
            this.props.dispatch(updateVideo(curVideo));
            this.setState({isAddModal: false});
        } else {
            this.setState({editError: editError});
        }
    }

    editVideo (assetId) {
        const video = this.getVideoById(assetId);
        this.setState({isAddModal: true, curVideo: video});
    }

    getVideoById = (id) => {
        const { videos } = this.props;
        var data = videos.filter(function( v ) {
            return v.AssetId == id;
        });

        var video = null;
        if (data.length > 0) {
            video = {... data[0]};
        }
        return video;
    }

    removeVideo(id) {
        this.closeDeleteModal();
        this.props.dispatch(deleteVideo(id));
    }

    closeEditModal = () => {
        this.setState({isAddModal: false, editError: ""});
    }

    openDeleteModal = (assetId) => {
        this.setState({ deleteAssetId: assetId });
    }

    closeDeleteModal = () => {
        this.setState({ deleteAssetId: null });
    }

    apiFormatter(cell, row) {
        return (
            <div className={screen.cardActions}>
                <button
                    type="button"
                    className={screen.secondaryBtn}
                    onClick={() => this.editVideo(row.AssetId)}
                >
                    {this.props.t('common.edit')}
                </button>
                <button
                    type="button"
                    className={screen.dangerBtn}
                    onClick={() => this.openDeleteModal(row.AssetId)}
                    disabled={this.props.isDeleting && this.props.idToDelete === row.AssetId}
                >
                    {this.props.isDeleting && this.props.idToDelete === row.AssetId ? <Loader size={14}/> : this.props.t('common.delete')}
                </button>
            </div>
        );
    }

    imageFormatter(cell) {
        if (cell == "" || cell == null ) {
            return (<div></div>);
        }
        return (
            <img src={cell} alt="" className={screen.thumb} />
        );
    }

    render() {
        const { t } = this.props;
        const {curVideo, videoError, videoName, videoFile, tempPicture, isAddModal, editError, deleteAssetId} = this.state;
        const { videos } = this.props;
        const deleteVideoRow = deleteAssetId != null ? this.getVideoById(deleteAssetId) : null;

        return (
            <div className={screen.sectionCard}>
                <div className={screen.sectionCardHeader}>{t('customerScreen.videos')}</div>
                <div className={screen.sectionCardBody}>
                    <p className={screen.noteText}>{t('customerScreen.videosIntro')}</p>
                    <form onSubmit={this.onClickSaveVideo}>
                        <label className={screen.uploadDrop}>
                            <input type="file" onChange={this.changePicture} accept="image/*"/>
                            <i className="zmdi zmdi-image-alt"></i>
                            <span>{tempPicture ? t('customerScreen.replacePoster') : t('customerScreen.choosePoster')}</span>
                        </label>
                        {tempPicture ? (
                            <img src={tempPicture} alt="" className={screen.preview} />
                        ) : null}
                        <label className={screen.uploadDrop}>
                            <input type="file" onChange={this.changeVideo} accept="video/mp4"/>
                            <i className="zmdi zmdi-collection-video"></i>
                            <span>{videoFile ? t('customerScreen.replaceVideo') : t('customerScreen.chooseVideo')}</span>
                        </label>
                        {videoFile ? (
                            <p className={screen.fileName}>{videoFile.name}</p>
                        ) : (
                            <p className={screen.helpText}>{t('customerScreen.mp4Only')}</p>
                        )}
                        <div className={screen.field}>
                            <label htmlFor="customer-screen-video-name">{t('customerScreen.videoName')}</label>
                            <input
                                id="customer-screen-video-name"
                                type="text"
                                className="form-control"
                                value={videoName}
                                onChange={this.changeName}
                            />
                        </div>
                        {videoError ? (
                            <Alert className="alert-sm" color="danger">{videoError}</Alert>
                        ) : null}
                        <button type="submit" className={screen.primaryBtn}>{t('customerScreen.saveVideo')}</button>
                    </form>
                    <div className={screen.tableWrap}>
                        <NativeTable
                            data={videos}
                            columns={[
                                { key: 'Thumbnail', header: t('customerScreen.poster'), render: (cell) => this.imageFormatter(cell) },
                                { key: 'Name', header: t('common.name') },
                                { key: 'AssetId', header: '', render: (cell, row) => this.apiFormatter(cell, row) },
                            ]}
                        />
                    </div>
                </div>
                <Modal isOpen={isAddModal} toggle={this.closeEditModal} modalClassName={screen.darkModal}>
                    <ModalHeader toggle={this.closeEditModal}>{t('customerScreen.editVideoName')}</ModalHeader>
                    <ModalBody>
                        {editError ? (
                            <Alert className="alert-sm" color="danger">{editError}</Alert>
                        ) : null}
                        {curVideo ? (
                            <div className={screen.field}>
                                <label htmlFor="customer-screen-edit-video-name">{t('customerScreen.videoName')}</label>
                                <input
                                    id="customer-screen-edit-video-name"
                                    type="text"
                                    className="form-control"
                                    value={curVideo.Name}
                                    onChange={this.changeEditVideoName}
                                />
                            </div>
                        ) : null}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" outline onClick={this.closeEditModal}>{t('common.cancel')}</Button>
                        <Button color="primary" onClick={this.onClickUpdate}>{t('common.update')}</Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={deleteAssetId != null} toggle={this.closeDeleteModal} modalClassName={screen.darkModal}>
                    <ModalHeader toggle={this.closeDeleteModal}>{t('customerScreen.deleteVideo')}</ModalHeader>
                    <ModalBody>
                        {deleteVideoRow
                            ? t('customerScreen.deleteVideoNamed', { name: deleteVideoRow.Name })
                            : t('customerScreen.deleteVideoBody')}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" outline onClick={this.closeDeleteModal}>{t('common.cancel')}</Button>
                        <Button
                            color="danger"
                            onClick={() => this.removeVideo(deleteAssetId)}
                            disabled={this.props.isDeleting}
                        >
                            {this.props.isDeleting ? <Loader size={14}/> : t('common.delete')}
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        videos: state.settings.videos,
        isReceiving: state.settings.isReceiving,
        isUpdating: state.settings.isUpdating,
        isDeleting: state.settings.isDeleting,
        idToDelete: state.settings.idToDelete,
    };
}

export default withRouter(connect(mapStateToProps)(withTranslation(Videos)));
